var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('upload-files',{attrs:{"max":_vm.content.allowPhotoNum,"min":_vm.content.allowMinPhotoNum,"allow-types":_vm.content.allowFileTypes},model:{value:(_vm.content.fileList),callback:function ($$v) {_vm.$set(_vm.content, "fileList", $$v)},expression:"content.fileList"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }